import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VRow,{attrs:{"no-gutters":""}},[_c(VCol,{attrs:{"cols":"12"}},[_c(VCard,{attrs:{"flat":""}},[_vm._v(" Kiosk Update ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }